import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import API from "../../Services/BaseService";
import "../../Component/CommonPopup/commonPopup.css";
import PageNotFound from "../FallBackUI/PageNotFound";
import Loading from "../../Component/Loading/Loading";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const Counter = (props) => {
  const [loading, setLoading] = useState(true);
  const sellerData = useSelector((state) => state.LoginReducer.payload);
  const [dealerList, setDealerList] = useState("");
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  useEffect(() => {
    BidList();
  }, []);

  const BidList = () => {
    let request = {
      car_id: props.carId,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    };

    API.post("bidinfolist/condition", request)
      .then((response) => {
        if (response.data.success === true) {
          setLoading(false);
          setDealerList(response.data.data);
        } else {
          setErrors(response.data.error.name);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  };

  function formatTime(value) {
    let local = new Date(value);
    let offset = local.getTimezoneOffset();
    value = new Date(local.getTime() - offset * 60000);
    value = moment(value).format("MMMM D, YYYY hh:mm A");
    return value;
  }

  return (
    <Modal
      show={true}
      onHide={props.toggle}
      size="xl" /* backdrop="static" keyboard={false} */
    >
      <Modal.Header className="Terms-login">
        <h2> Bid Details</h2>
      </Modal.Header>
      <Modal.Body>
        {errorFlag === true ? (
          <PageNotFound error={errors} />
        ) : loading ? (
          <Loading />
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table class="bidinfo-table">
              <thead className="Bidlist">
                <tr>
                  <th className="sealrow">Buyer Dealer Name</th>
                  <th className="sealrow">Buyer Name</th>
                  <th className="sealrow">Bid Type</th>
                  <th className="sealrow">Bid Amount</th>
                  <th className="sealrow">Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {dealerList.length > 0 ? (
                  dealerList.sort().map((dealer, index) => (
                    <tr key={index}>
                      <td>{dealer.dealer_name}</td>
                      <td>{dealer.buyername}</td>
                      <td>{dealer.type}</td>
                      <td>${dealer.bid}</td>
                      <td>{formatTime(dealer.biddate)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center bit-list">
                      <p>No Data Found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <div class="Close-info">
          <button className="cta-btns-primary" onClick={props.toggle}>
            Close
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Counter;
